import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { noop } from 'lodash';

import ButtonContentView from '../ButtonContentView';

const ButtonContentForm = ({ block, readOnly, submit, ...rest }) => (
  <Field
    name="value"
    component={ButtonContentView}
    props={{
      ...rest,
      block,
      onClick: readOnly || block.url ? noop : submit,
      readOnly,
    }}
  />
);

ButtonContentForm.propTypes = {
  block: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  submit: PropTypes.func,
};

export default reduxForm({
  form: 'ButtonContentForm',
})(ButtonContentForm);
